import { render, staticRenderFns } from "./AccountTypeEdit.vue?vue&type=template&id=f2b11774&"
import script from "./AccountTypeEdit.vue?vue&type=script&lang=ts&"
export * from "./AccountTypeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b11774')) {
      api.createRecord('f2b11774', component.options)
    } else {
      api.reload('f2b11774', component.options)
    }
    module.hot.accept("./AccountTypeEdit.vue?vue&type=template&id=f2b11774&", function () {
      api.rerender('f2b11774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/accountType/AccountTypeEdit.vue"
export default component.exports